import React, { memo } from "react";

import "./HawkeyeV2FilterInfo.scss";

function HawkeyeV2FilterInfo(props) {
  const { infoFilter, openEditFilter, closeShowInfo, enableEdit } = props;

  const edit = () => {
    closeShowInfo();
    openEditFilter(infoFilter);
  };

  return (
    <div className="hawkeye-filter-modal">
      <div className="hawkeye-filter-modal-content">
        <h3 className="hawkeye-filter-modal-title">
          Selected filters values in {infoFilter.filterName}
        </h3>
        <div className="hawkeye-filter-modal-body">
          <div className="hawkeye-filter-info">
            {infoFilter.filterSettings.map((f, index) => (
              <div key={index}>
                <h4 className="hawkeye-filter-info-title">
                  {`${f.filter.displayName} - ${f.values.length} selected`}
                </h4>
                {f.values.map((v) => (
                  <span className="hawkeye-filter-info-tag" key={`${v}_${index}`}>
                    {v}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="hawkeye-filter-modal-footer">
          <button onClick={closeShowInfo} className="hawkeye-btn hawkeye-btn-secondary">
            Close
          </button>
          {enableEdit && infoFilter.isEditable && (
            <button onClick={edit} className="hawkeye-btn hawkeye-btn-primary">
              Edit
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(HawkeyeV2FilterInfo);
